module.exports = __webpack_public_path__ + "media/images/icon_area-43c5e635eae809c469a79f6493ea0e45.svg";